import React, { useState } from "react";
import { Query } from "react-apollo";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { CountryRegionData } from "react-country-region-selector";
import { CountryRegionDataUSFirst } from "common/countries";
import { Mutation } from "react-apollo";
import { GET_USER_INFO, getAllDealerOptions } from "queries";
import { toast } from "react-toastify";
import useForm from "components/useForm";
import "../../../pages/BoatShow/BoatShowEdit.scss";
import auth from "Auth";
import { ADD_BOATSHOWS } from "pages/BoatShow/queries";
import { useQuery } from "@apollo/client";
import { DEALER_ASSIGN_BOAT, GET_MY_DEALERS_SALE } from "../queries";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    textAlign: "center",
    margin: "auto",
    marginBottom: "20px",
  },
  dense: {
    marginTop: 19,
  },
  textColor: {
    color: "red",
    fontSize: "12px",
  },
  tooltipStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    marginBottom: "1em",
  },
}));

const getRegions = (country) => {
  if (!country) {
    return [];
  }

  return country?.split("|")?.map((regionPair) => {
    let [regionName, regionShortCode = null] = regionPair.split("~");
    return regionName;
  });
};

const getBrands = (profile) => {
  const brands = [];
  if (profile?.has_skiff) brands.push("Carolina Skiff");
  if (profile?.has_funchaser) brands.push("Fun Chaser");
  if (profile?.has_seachaser) brands.push("Sea Chaser");
  return brands.join("/");
};

const SalesBoatShowAdd = (props) => {
  const { values, setValues, resetState } = useForm(submitForm);
  const [isSubmit, setIsSubmit] = useState(false);
  const [errors, setErrors] = useState({
    start_date: "",
    end_date: "",
  });
  const classes = useStyles();
  function submitForm() {}
  function completedAdd(payload) {
    toast("Boat Show has been Added");
    resetState();
    setIsSubmit(false);
  }

  // const { loading, data: profileData, error } = useQuery(getAllDealerOptions);
  const { data: profileData, loading: profileLoading } = useQuery(
    GET_MY_DEALERS_SALE,
    {
      notifyOnNetworkStatusChange: true,
      variables: { profile_id: auth.getSub() },
      fetchPolicy: "cache-and-network",
    }
  );

  const handleChange = (event, text) => {
    const { name, value } = event.target;
    let newValue;
    const finalValue = value?.trim()?.length > 0 ? value : "";

    if (text === "text") {
      newValue = finalValue;
    } else {
      newValue = value;
    }
    setValues({
      ...values,
      [name]: newValue,
    });

    // Validate End Date against Start Date
    if (name === "end_date") {
      const startDate = new Date(values.start_date);
      const endDate = new Date(value);

      if (endDate < startDate) {
        setErrors({
          ...errors,
          [name]: "End Date must be greater than or equal to Start Date",
        });
      } else {
        setErrors({
          ...errors,
          [name]: "",
        });
      }
    }
  };

  return (
    <Query query={GET_USER_INFO} variables={{ id: auth.getSub() }}>
      {({ loading, error, data }) => {
        if (loading || profileLoading) return null;
        if (error) return `Error! ${error}`;

        if (data.profiles_by_pk !== undefined) {
          return (
            <Mutation mutation={ADD_BOATSHOWS}>
              {(addTodo, { data, loading, called, error }) => {
                return (
                  <div style={{ margin: "20px" }}>
                    <Mutation
                      mutation={DEALER_ASSIGN_BOAT}
                      onCompleted={completedAdd}
                      onError={() => setIsSubmit(false)}
                    >
                      {(
                        dealer_assign_boat,
                        { data, loading, called, error }
                      ) => {
                        return (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              if (!values.site) {
                                toast.error("Please select a site");
                              } else {
                                // Save the show against the selected dealer, not the rep
                                const selectedDealer =
                                  profileData?.sales_assign?.find(
                                    (option) =>
                                      option?.assign_profiles?.profile_id ===
                                      values?.profile_id
                                  )?.assign_profiles;
                                values.country = values?.country?.[0];
                                values.dealer =
                                  selectedDealer?.company ||
                                  selectedDealer?.name;
                                values.brands = getBrands(selectedDealer);
                                setIsSubmit(true);
                                addTodo({
                                  variables: {
                                    objects: [values],
                                  },
                                }).then((res) => {
                                  dealer_assign_boat({
                                    variables: {
                                      objects: [
                                        {
                                          boat_id:
                                            res?.data?.insert_boat_shows
                                              ?.returning?.[0]?.id,
                                          dealer_id: values?.profile_id,
                                        },
                                      ],
                                    },
                                  }).catch((err) => {
                                    toast.error(err.toString());
                                  });
                                });
                              }
                            }}
                            className={classes.container}
                            autoComplete="off"
                          >
                            <Grid
                              container
                              direction="row"
                              justify="center"
                              alignItems="center"
                            >
                              <Typography
                                gutterBottom
                                variant="h2"
                                style={{
                                  fontSize: "20px",
                                  fontWeight: "300",
                                  textTransform: "uppercase",
                                  paddingBottom: "1em",
                                }}
                              >
                                {auth.getRole().toLowerCase() === "admin"
                                  ? "Add New Boat Show"
                                  : "ADD NEW BOAT SHOW"}
                              </Typography>
                              <Grid container>
                                {/* Row 1 */}
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    id="name"
                                    name="name"
                                    variant="outlined"
                                    label="Name of Show "
                                    placeholder="Name of Show "
                                    className={classes.textField}
                                    InputLabelProps={{ shrink: true }}
                                    margin="normal"
                                    onChange={(e) => handleChange(e, "text")}
                                    value={values.name || ""}
                                    required
                                  />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    id="start_date"
                                    name="start_date"
                                    label="Start Date"
                                    variant="outlined"
                                    placeholder="Start Date"
                                    type="date"
                                    className={classes.textField}
                                    margin="normal"
                                    onChange={handleChange}
                                    value={
                                      values.start_date || new Date().getDate()
                                    }
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    required
                                    error={Boolean(errors.end_date)}
                                    helperText={errors.end_date}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    id="end_date"
                                    name="end_date"
                                    label="End Date"
                                    variant="outlined"
                                    placeholder="End Date"
                                    type="date"
                                    className={classes.textField}
                                    margin="normal"
                                    onChange={handleChange}
                                    value={
                                      values.end_date || new Date().getDate()
                                    }
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    required
                                  />
                                </Grid>
                              </Grid>
                              <Grid container>
                                {/* Row 2 */}
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    id="address"
                                    name="address"
                                    label="Address"
                                    variant="outlined"
                                    placeholder="Address"
                                    className={classes.textField}
                                    margin="normal"
                                    onChange={(e) => handleChange(e, "text")}
                                    value={values.address || ""}
                                    required
                                  />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    id="address2"
                                    name="address2"
                                    variant="outlined"
                                    label="SUITE , APT # , Optional"
                                    placeholder="SUITE , APT # , Optional"
                                    className={classes.textField}
                                    margin="normal"
                                    onChange={(e) => handleChange(e, "text")}
                                    value={values.address2 || ""}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    required
                                    variant="outlined"
                                    name="country"
                                    label="Country"
                                    select
                                    onChange={handleChange}
                                    value={values.country || ""}
                                    className={classes.textField}
                                    SelectProps={{
                                      native: true,
                                      MenuProps: {
                                        className: classes.menu,
                                      },
                                    }}
                                    inputProps={{
                                      name: "country",
                                      id: "country",
                                    }}
                                  >
                                    <option value=""></option>
                                    {CountryRegionDataUSFirst.map((option, index) => {
                                      return (
                                        <option
                                          key={option[0]}
                                          value={option[2]}
                                        >
                                          {option[0]}
                                        </option>
                                      );
                                    })}
                                  </TextField>
                                </Grid>
                              </Grid>
                              {/* Row 3 */}
                              <Grid container>
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    id="city"
                                    name="city"
                                    label="City"
                                    variant="outlined"
                                    placeholder="City"
                                    className={classes.textField}
                                    margin="normal"
                                    onChange={(e) => handleChange(e, "text")}
                                    value={values.city || ""}
                                    required
                                  />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    id="zipcode"
                                    name="zipcode"
                                    label="Zipcode"
                                    variant="outlined"
                                    placeholder="Zipcode"
                                    className={classes.textField}
                                    margin="normal"
                                    onChange={(e) => handleChange(e, "text")}
                                    value={values.zipcode || ""}
                                    required
                                  />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} align="left">
                                  <TextField
                                    required
                                    variant="outlined"
                                    name="region"
                                    label="State/Region"
                                    select
                                    onChange={handleChange}
                                    value={values.region || ""}
                                    className={classes.textField}
                                    SelectProps={{
                                      native: true,
                                      MenuProps: {
                                        className: classes.menu,
                                      },
                                    }}
                                    inputProps={{
                                      name: "region",
                                      id: "region",
                                    }}
                                  >
                                    <option value=""></option>
                                    {getRegions(values.country)?.map(
                                      (option, index) => {
                                        return (
                                          <option
                                            key={option[0]}
                                            value={option}
                                          >
                                            {option}
                                          </option>
                                        );
                                      }
                                    )}
                                  </TextField>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  align="center"
                                >
                                  <TextField
                                    id="description"
                                    name="description"
                                    label="Boat Event Description"
                                    variant="outlined"
                                    style={{ width: "100%" }}
                                    placeholder="Boat Event Description"
                                    helperText="Max 700 words"
                                    margin="normal"
                                    onChange={(e) => handleChange(e, "text")}
                                    value={values.description || ""}
                                    required
                                    multiline
                                    rows="4"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                              <Grid
                                container
                                spacing={4}
                                style={{
                                  marginBottom: "1em",
                                }}
                              >
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={6}
                                  align="center"
                                  className={classes.tooltipStyle}
                                  style={{ position: "relative" }}
                                >
                                  <TextField
                                    required
                                    variant="outlined"
                                    name="site"
                                    label="Site"
                                    select
                                    onChange={handleChange}
                                    value={values.site || ""}
                                    className={classes.textField}
                                    SelectProps={{
                                      native: true,
                                      MenuProps: {
                                        className: classes.menu,
                                      },
                                    }}
                                    inputProps={{
                                      name: "site",
                                      id: "site",
                                    }}
                                  >
                                    <option value=""></option>
                                    <option value="CarolinaSkiff">
                                      Carolina Skiff
                                    </option>
                                    <option value="SeaChaser">
                                      Sea Chaser
                                    </option>
                                    <option value="CarolinaSkiff,SeaChaser">
                                      CarolinaSkiff/ SeaChaser
                                    </option>
                                  </TextField>
                                  <p
                                    className={classes.textColor}
                                    style={{
                                      position: "absolute",
                                      bottom: "-10px",
                                    }}
                                  >
                                    Please select both the sites if you want to
                                    display the boat show on both of them.
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={6}
                                  align="center"
                                  className={classes.tooltipStyle}
                                >
                                  <TextField
                                    required
                                    name="profile_id"
                                    label="Select Dealer"
                                    variant="outlined"
                                    select
                                    className={classes.textField}
                                    value={values?.profile_id || ""}
                                    onChange={handleChange}
                                    SelectProps={{
                                      native: true,
                                      MenuProps: {
                                        className: classes.menu,
                                      },
                                    }}
                                  >
                                    <option value=""></option>
                                    {profileData?.sales_assign &&
                                      profileData?.sales_assign?.map(
                                        (option) => (
                                          <option
                                            key={
                                              option?.assign_profiles
                                                ?.profile_id
                                            }
                                            value={
                                              option?.assign_profiles
                                                ?.profile_id
                                            }
                                          >
                                            {option?.assign_profiles?.name}
                                            {option?.assign_profiles?.status ===
                                            "archived"
                                              ? " - Archived"
                                              : ""}
                                          </option>
                                        )
                                      )}
                                  </TextField>
                                </Grid>
                              </Grid>
                              <Grid item xs={12} align="center">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className={classes.button}
                                  type="submit"
                                  disabled={isSubmit}
                                >
                                  Add New Boat Show
                                </Button>
                              </Grid>
                            </Grid>
                          </form>
                        );
                      }}
                    </Mutation>
                  </div>
                );
              }}
            </Mutation>
          );
        }
      }}
    </Query>
  );
};

export default SalesBoatShowAdd;
